import type { AttentionItem, AttentionRole, AttentionSeverity } from "./types";
import { ROUTES, MY_QUESTS_ROUTE, workspaceRoute } from "@/lib/constants";

const SEVERITY_RANK: Record<AttentionSeverity, number> = {
  urgent: 0,
  action: 1,
  waiting: 2,
  info: 3,
};

export function sortItems(items: AttentionItem[]): AttentionItem[] {
  return [...items].sort((a, b) => {
    const s = SEVERITY_RANK[a.severity] - SEVERITY_RANK[b.severity];
    if (s !== 0) return s;
    return Date.parse(a.since ?? "") - Date.parse(b.since ?? "") || 0;
  });
}

export function linkFor(item: AttentionItem): string {
  if (item.kind === "stale_draft") return MY_QUESTS_ROUTE;
  // A creator's counter-offer is answered on the task page, not in the chat.
  if (item.kind === "proposal_to_answer" && item.taskId && item.role !== "creator") {
    return ROUTES.TASK_DETAIL.replace(":id", item.questId).replace(":taskId", item.taskId);
  }
  if (item.taskId && item.role !== "creator") return workspaceRoute(item.questId, item.taskId);
  return ROUTES.QUEST_DETAIL.replace(":id", item.questId);
}

/** Waiting on the reader now — the rows a badge counts and the digest leads with. */
export function isActionable(item: Pick<AttentionItem, "severity">): boolean {
  return item.severity === "urgent" || item.severity === "action";
}

export function needsMeCount(items: AttentionItem[], role?: AttentionRole): number {
  return items.filter((i) => isActionable(i) && (!role || i.role === role)).length;
}
